import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "micro_expand",
  "use": "micro_expand-usage",
  "viewBox": "0 0 10 10",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 10\" id=\"micro_expand\"><path d=\"M1.938 3 5 6.5 8.063 3H9.5L5 8 .5 3z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol